import type {
  BenchmarkClienteFazendas,
  BenchmarkLocalUserStatus,
} from "services/BenchmarkService";

export const FETCH_BENCHMARK_ACCESS_DETAILS_FOR_LOGGED_USER =
  "FETCH_BENCHMARK_ACCESS_DETAILS_FOR_LOGGED_USER";
export const FETCH_BENCHMARK_ACCESS_FOR_TARGET_USER =
  "FETCH_BENCHMARK_ACCESS_FOR_TARGET_USER";
export const FETCH_BENCHMARK_ACCESS_FOR_FARM =
  "FETCH_BENCHMARK_ACCESS_FOR_FARM";
export const SET_BENCHMARK_EDIT_USER_STATUS =
  "SET_BENCHMARK_EDIT_USER_STATUS";
export const SET_BENCHMARK_EDIT_USER_ASSOCIACOES =
  "SET_BENCHMARK_EDIT_USER_ASSOCIACOES";
export const SET_BENCHMARK_EDIT_USER_CARREGANDO =
  "SET_BENCHMARK_EDIT_USER_CARREGANDO";
export const RESET_BENCHMARK_EDIT_USER = "RESET_BENCHMARK_EDIT_USER";

export type BenchmarkDispatchAction =
  | {
      type: typeof FETCH_BENCHMARK_ACCESS_DETAILS_FOR_LOGGED_USER;
      payload: { hasAccess: boolean; hasContextualAccess: boolean };
    }
  | {
      type: typeof FETCH_BENCHMARK_ACCESS_FOR_TARGET_USER;
      payload: { hasAccess: boolean; targetUserEmail: string };
    }
  | {
      type: typeof FETCH_BENCHMARK_ACCESS_FOR_FARM;
      payload: { hasAccess: boolean; farmId: number };
    }
  | {
      type: typeof SET_BENCHMARK_EDIT_USER_STATUS;
      payload: { localUserStatus: BenchmarkLocalUserStatus; hasUserAccess: boolean };
    }
  | {
      type: typeof SET_BENCHMARK_EDIT_USER_ASSOCIACOES;
      payload: { associacoes: BenchmarkClienteFazendas[] };
    }
  | {
      type: typeof SET_BENCHMARK_EDIT_USER_CARREGANDO;
      payload: { carregando: boolean };
    }
  | { type: typeof RESET_BENCHMARK_EDIT_USER };

export const fetchBenchmarkAccessForLoggedUserAction = (accessDetails: {
  hasAccess: boolean;
  hasContextualAccess: boolean;
}): BenchmarkDispatchAction => ({
  type: FETCH_BENCHMARK_ACCESS_DETAILS_FOR_LOGGED_USER,
  payload: accessDetails,
});

export const fetchBenchmarkAccessForTargetUserAction = (accessDetails: {
  hasAccess: boolean;
  targetUserEmail: string;
}): BenchmarkDispatchAction => ({
  type: FETCH_BENCHMARK_ACCESS_FOR_TARGET_USER,
  payload: accessDetails,
});

export const fetchBenchmarkAccessForFarmAction = (accessDetails: {
  hasAccess: boolean;
  farmId: number;
}): BenchmarkDispatchAction => ({
  type: FETCH_BENCHMARK_ACCESS_FOR_FARM,
  payload: accessDetails,
});

export const setBenchmarkEditUserStatusAction = (payload: {
  localUserStatus: BenchmarkLocalUserStatus;
  hasUserAccess: boolean;
}): BenchmarkDispatchAction => ({
  type: SET_BENCHMARK_EDIT_USER_STATUS,
  payload,
});

export const setBenchmarkEditUserAssociacoesAction = (
  associacoes: BenchmarkClienteFazendas[],
): BenchmarkDispatchAction => ({
  type: SET_BENCHMARK_EDIT_USER_ASSOCIACOES,
  payload: { associacoes },
});

export const setBenchmarkEditUserCarregandoAction = (
  carregando: boolean,
): BenchmarkDispatchAction => ({
  type: SET_BENCHMARK_EDIT_USER_CARREGANDO,
  payload: { carregando },
});

export const resetBenchmarkEditUserAction = (): BenchmarkDispatchAction => ({
  type: RESET_BENCHMARK_EDIT_USER,
});
